import React from 'react';

export type SupplierPerformanceTableColumnsArgs = {
	supplierCount: number;
	renderSupplierName: (text: any, record: any) => React.ReactNode;
	renderWoCount: (value: any) => any;
	renderDurationColumn: (value: any) => any;
	renderFirstTimeFixRate: (value: any) => any;
	sortWoCount: (a: any, b: any) => number;
	sortAvgResponseTime: (a: any, b: any) => number;
	sortAvgResolutionTime: (a: any, b: any) => number;
	sortFirstTimeFixRate: (a: any, b: any) => number;
};

export function buildSupplierPerformanceTableColumns({
	supplierCount,
	renderSupplierName,
	renderWoCount,
	renderDurationColumn,
	renderFirstTimeFixRate,
	sortWoCount,
	sortAvgResponseTime,
	sortAvgResolutionTime,
	sortFirstTimeFixRate,
}: SupplierPerformanceTableColumnsArgs) {
	return [
		{
			title: `Suppliers (${supplierCount})`,
			dataIndex: 'supplierFacilityName',
			key: 'supplierFacilityName',
			width: '32%',
			render: renderSupplierName,
			onCell: () => ({ style: { padding: 16 } }),
			onHeaderCell: () => ({ style: { padding: 16 } }),
		},
		{
			title: 'WOs',
			dataIndex: 'woCount',
			key: 'woCount',
			sorter: sortWoCount,
			defaultSortOrder: 'descend',
			render: renderWoCount,
		},
		{
			title: 'Response time [Avg]',
			dataIndex: 'avgResponseTimeSecondsDisplay',
			key: 'avgResponseTimeSeconds',
			sorter: sortAvgResponseTime,
			render: renderDurationColumn,
		},
		{
			title: 'Resolution time [Avg]',
			dataIndex: 'avgResolutionTimeSecondsDisplay',
			key: 'avgResolutionTimeSeconds',
			sorter: sortAvgResolutionTime,
			render: renderDurationColumn,
		},
		{
			title: 'First time fix',
			dataIndex: 'firstTimeFixRateDisplay',
			key: 'firstTimeFixRate',
			sorter: sortFirstTimeFixRate,
			render: renderFirstTimeFixRate,
		},
	];
}
